"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_portal_1 = require("react-portal");
const styled_components_1 = __importDefault(require("styled-components"));
const formatting_1 = __importDefault(require("../menus/formatting"));
const LinkEditor_1 = __importDefault(require("./LinkEditor"));
const Menu_1 = __importDefault(require("./Menu"));
const isMarkActive_1 = __importDefault(require("../queries/isMarkActive"));
const getMarkRange_1 = __importDefault(require("../queries/getMarkRange"));
const SSR = typeof window === "undefined";
class FormattingToolbar extends React.Component {
    constructor() {
        super(...arguments);
        this.menuRef = React.createRef();
        this.state = {
            left: 0,
            top: 0,
            offset: 0,
        };
    }
    componentDidMount() {
        this.setState(this.calculatePosition(this.props));
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState(this.calculatePosition(nextProps));
    }
    calculatePosition(props) {
        const { view } = props;
        const { selection } = view.state;
        if (!selection || selection.empty || selection.node || SSR) {
            return {
                left: -1000,
                top: 0,
            };
        }
        const startPos = view.coordsAtPos(selection.$from.pos);
        const endPos = view.coordsAtPos(selection.$to.pos);
        const halfSelection = Math.abs(endPos.left - startPos.left) / 2;
        const centerOfSelection = startPos.left + halfSelection;
        const { offsetWidth, offsetHeight } = this.menuRef.current;
        const margin = 12;
        const left = Math.min(window.innerWidth - offsetWidth - margin, Math.max(margin, centerOfSelection - offsetWidth / 2));
        const top = Math.min(window.innerHeight - offsetHeight - margin, Math.max(margin, startPos.top - offsetHeight));
        const offset = left - (centerOfSelection - offsetWidth / 2);
        return {
            left: left + window.scrollX,
            top: top + window.scrollY,
            offset,
        };
    }
    render() {
        const { view } = this.props;
        const { state } = view;
        const isActive = !state.selection.empty;
        const items = formatting_1.default(state);
        const link = isMarkActive_1.default(state.schema.marks.link)(state);
        const range = getMarkRange_1.default(state.selection.$from, state.schema.marks.link);
        return (React.createElement(react_portal_1.Portal, null,
            React.createElement(Wrapper, { active: isActive, ref: this.menuRef, top: this.state.top, left: this.state.left, offset: this.state.offset }, link && range ? (React.createElement(LinkEditor_1.default, Object.assign({ mark: range.mark, from: range.from, to: range.to }, this.props))) : (React.createElement(Menu_1.default, Object.assign({ items: items }, this.props))))));
    }
}
exports.default = FormattingToolbar;
const Wrapper = styled_components_1.default.div `
  padding: 8px 16px;
  position: absolute;
  z-index: ${props => {
    return props.theme.zIndex + 100;
}};
  top: ${props => props.top}px;
  left: ${props => props.left}px;
  width: 316px;
  opacity: 0;
  background-color: ${props => props.theme.toolbarBackground};
  border-radius: 4px;
  transform: scale(0.95);
  transition: opacity 150ms cubic-bezier(0.175, 0.885, 0.32, 1.275),
    transform 150ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transition-delay: 150ms;
  line-height: 0;
  height: 40px;
  box-sizing: border-box;
  pointer-events: none;
  white-space: nowrap;

  &::before {
    content: "";
    display: block;
    width: 24px;
    height: 24px;
    transform: translateX(-50%) rotate(45deg);
    background: ${props => props.theme.toolbarBackground};
    border-radius: 3px;
    z-index: -1;
    position: absolute;
    bottom: -2px;
    left: calc(50% - ${props => props.offset || 0}px);
  }

  * {
    box-sizing: border-box;
  }

  ${({ active }) => active &&
    `
    transform: translateY(-6px) scale(1);
    pointer-events: all;
    opacity: 1;
  `};

  @media print {
    display: none;
  }
`;
//# sourceMappingURL=FormattingToolbar.js.map